import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-model3d-help',
  templateUrl: './model3d-help.component.html',
  styleUrls: ['./model3d-help.component.scss'],
})
export class Model3dHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
